/**
 * Servicio para generar el formato de impresión oficial de EPTAM 
 */
export const ReporteService = {
  
  generarHTMLServicio(ticket, intervencion) {
    // Definimos los estilos específicos para que se vea igual al PDF [cite: 1, 2, 3, 4, 5]
    const estilos = `
      <style>
        @media print { .no-print { display: none; } }
        .formulario-tamep { font-family: Arial, sans-serif; width: 210mm; padding: 15mm; margin: auto; border: 1px solid #eee; }
        .header-table { width: 100%; border-collapse: collapse; }
        .logo-section { width: 40%; text-align: left; }
        .title-section { width: 60%; text-align: center; }
        .text-xxs { font-size: 8px; }
        .text-xs { font-size: 10px; }
        .text-sm { font-size: 12px; }
        .border-box { border: 1px solid black; margin-top: 10px; }
        .bg-light { background-color: #f2f2f2; }
        .table-categorias { width: 100%; border-collapse: collapse; margin-top: 5px; text-align: center; font-size: 9px; }
        .table-categorias td { border: 1px solid black; padding: 4px; }
        .section-title { font-weight: bold; padding: 3px; border-bottom: 1px solid black; }
        .content-box { padding: 10px; min-height: 80px; }
        .firma-box { border-top: 1px solid black; width: 80%; margin: 40px auto 5px auto; }
      </style>
    `;

    // Mapeo de categorías según el formato oficial 
    const cat = ticket.tipo_solicitud;
    const categoriasHTML = `
      <table class="table-categorias">
        <tr>
          <td>MESA DE AYUDA ${cat === 'AYUDA' ? '<b>[ X ]</b>' : '[  ]'}</td>
          <td>REDES [  ]</td>
          <td>SEGURIDAD [  ]</td>
          <td>SERVICIOS ${cat === 'SERVICIO' ? '<b>[ X ]</b>' : '[  ]'}</td>
          <td>DESARROLLO [  ]</td>
        </tr>
      </table>
    `;

    return `
      <html>
        <head>${estilos}</head>
        <body>
          <div class="formulario-tamep">
            <table class="header-table">
              <tr>
                <td class="logo-section">
                  <div class="text-sm"><b>tamep</b></div>
                  <div class="text-xxs">EMPRESA PÚBLICA [cite: 2]</div>
                  <div class="text-xxs">GERENCIA DE INFORMATICA Y COMUNICACIONES [cite: 3]</div>
                  <div class="text-xxs">BOLIVIA [cite: 4]</div>
                </td>
                <td class="title-section">
                  <div class="text-sm"><b>FORMULARIO DE SERVICIOS </b></div>
                  <div class="text-xs" style="margin-top:10px;">
                    G.I. y CC. EP-TAM N°: <b>${ticket.num_ticket || 'S/N'}</b>
                  </div>
                </td>
              </tr>
            </table>

            ${categoriasHTML}

            <div class="border-box">
              <div class="section-title bg-light text-xxs">DATOS DEL SOLICITANTE</div>
              <table class="text-xs" style="width:100%; padding: 5px;">
                <tr>
                  <td><b>Repartición[cite: 7]:</b> ${ticket.regional || '-'}</td>
                  <td><b>Fecha[cite: 19]:</b> ${new Date(ticket.fecha_solicitud).toLocaleDateString()}</td>
                </tr>
                <tr>
                  <td colspan="2"><b>Nombre[cite: 11]:</b> ${ticket.solicitante_nombre}</td>
                </tr>
                <tr>
                  <td colspan="2"><b>Cargo[cite: 12]:</b> ${ticket.solicitante_cargo || '-'}</td>
                </tr>
              </table>
            </div>

            <div class="border-box">
              <div class="section-title bg-light text-xxs">REQUERIMIENTO [cite: 16]</div>
              <div class="content-box text-xs">${ticket.descripcion_problema}</div>
            </div>

            <div class="border-box">
              <div class="section-title bg-light text-xxs">RESPUESTA A REQUERIMIENTO [cite: 36]</div>
              <div class="content-box text-xs">
                <b>Diagnóstico previo[cite: 16]:</b> ${intervencion.diagnostico_previo} <br><br>
                <b>Detalles de reparación:</b> ${intervencion.detalles_reparacion}
              </div>
            </div>

            <div style="margin-top: 30px;">
              <div class="text-xxs"><b>DATOS DE ENTREGA Y RECEPCIÓN [cite: 37]</b></div>
              <table style="width:100%; text-align:center; margin-top:20px;">
                <tr>
                  <td style="width:33%;">
                    <div class="firma-box"></div>
                    <div class="text-xxs">TÉCNICO ASIGNADO [cite: 31, 32]</div>
                    <div class="text-xxs">${intervencion.tecnico_nombre}</div>
                  </td>
                  <td style="width:33%;">
                    <div class="firma-box"></div>
                    <div class="text-xxs">ENTREGUE CONFORME [cite: 38]</div>
                    <div class="text-xxs">${intervencion.tecnico_nombre}</div>
                  </td>
                  <td style="width:33%;">
                    <div class="firma-box"></div>
                    <div class="text-xxs">RECIBÍ CONFORME [cite: 44]</div>
                    <div class="text-xxs">${intervencion.verificado_por}</div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </body>
      </html>
    `;
  },

  imprimir(html) {
    const ventana = window.open('', '_blank');
    ventana.document.write(html);
    ventana.document.close();
    ventana.focus();
    // Tiempo para cargar recursos antes de imprimir
    setTimeout(() => {
      ventana.print();
      ventana.close();
    }, 500);
  }
};